// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"448":"c930823c","453":"c873ab3d"}[chunkId] + ".chunk.js";
};